import { fromEvent, map } from "rxjs";

export default class RecommendedCheckbox {
  constructor() {
    this.id = 'includeRecommended';
    this.label = `<label for="${this.id}">
                    Also include communities from other builders with similar homes
                  </label>`;
  }

  set value(newValue){
    this.valueInput = newValue;
  }

  get value(){
    return this.valueInput;
  }

  getHtml() {
    return `<input id="${this.id}" data-qa="recommendations-checkbox" name="${this.id}" 
            type="checkbox" ${this.value ? 'checked=""' : ''} value="True">${this.label}`;
  }
  
  getNode() {
    return document.getElementById(this.id);
  }

  /**
   * getOnChangeEvent: On input change map its value to the storage property.
   */
  getOnChangeEvent() {
    return fromEvent(this.getNode(), 'change').pipe(
      map((event) => ({hasUserOptedIntoRecommendationEmail: event.target.checked}))
    );
  }
}
